<template>
	<div ref="nav">
		<nav class="navbar">
			<router-link tag="a" :to="`/`">
				<img src="@/assets/logo.png" alt="" class="logo logo-light" />
			</router-link>

			<div class="menu">
				<div class="item">
					Eventos
				</div>

				<div class="item" v-if="$store.getters.isAuthenticated">
					<b-dropdown right variant="link">
						<template #button-content>
							<div class="item user-item">
								<div>
									{{ $store.getters.loggedUser.name }} {{ $store.getters.loggedUser.lastname }} <br />
									<span v-if="$store.getters.loggedUser.isPromotor">RRPP</span>
								</div>
								<b-avatar class="ml-2" size="32px"></b-avatar>
							</div>
						</template>

						<b-dropdown-item href="/account/tickets"><strong>Mis tickets</strong></b-dropdown-item>
						<b-dropdown-item href="/account/memberships"><strong>Mis membresias</strong></b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<template v-if="$store.getters.loggedUser.isPromotor">
							<b-dropdown-item href="/account/events">Mis eventos</b-dropdown-item>
							<b-dropdown-divider></b-dropdown-divider>
						</template>
						<b-dropdown-item href="/account">Mi cuenta</b-dropdown-item>
						<b-dropdown-item href="/help">Ayuda</b-dropdown-item>

						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item href="/logout">Salir</b-dropdown-item>
					</b-dropdown>
				</div>
				<div class="item" v-else>
					<router-link tag="a" to="/login">
						Iniciar sesión
					</router-link>
				</div>
			</div>
		</nav>

		<!-- <div class="nav-spacer" ref="spacer" v-if="!navFixed"></div> -->

		<!-- <b-sidebar id="menu-sidebar" right shadow sidebar-class="sidebar-menu" no-header> -->
		<!-- <div class="d-flex justify-content-between">
					<div class="p-3">
						<img src="@/assets/logo.png" alt="" class="logo" />
					</div>
					<div class="btn btn-close p-3" v-b-toggle.menu-sidebar>
						<i class="icon icon-close"></i>
					</div>
				</div> -->

		<!-- <b-nav vertical class="mt-3">
					<b-nav-item to="/" class="btn-primary" active>Inicio </b-nav-item>
					<b-nav-item to="/campers" class="btn-primary">Campers</b-nav-item>
					<b-nav-item to="/productos" class="btn-primary">Accesorios</b-nav-item>
					<b-nav-item to="/quienes-somos" class="btn-primary">Quienes somos</b-nav-item>

					<b-nav-item to="/preguntas-frecuentes" class="btn-primary">Preguntas frecuentes </b-nav-item>
					<b-nav-item to="/contacto" class="btn-primary">Contacto </b-nav-item>
				</b-nav> -->
		<!-- </b-sidebar> -->
	</div>
</template>

<script>
export default {
	name: "Navbar",

	props: {},
	data() {
		return {}
	}
}
</script>
<style scoped lang="scss">
.navbar {
	top: 0px;
	width: 100%;
	background-color: #fff;
	padding: 0px 18px;
	transition: all 0.2s ease-in-out;
	height: 64px;
	z-index: 10;
	position: absolute;

	.logo {
		width: 123px;
	}

	.menu {
		flex-grow: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;

		.item {
			font-size: 14px;
			line-height: 14px;
			font-weight: 500;
			color: rgb(20, 20, 20);
			margin-right: 10px;
		}
		.user-item {
			display: flex;
			align-items: center;
			text-align: right;

			span {
				font-weight: 400;
			}
		}

		& /deep/ .btn {
			text-decoration: none;
			color: inherit;
		}
		& /deep/ .dropdown-menu {
			width: 240px;
			box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

			.dropdown-item {
				padding: 0.9rem 1.5rem;
			}
		}
	}
}
</style>
